"use strict";
import classNames from "classnames";
import { cleanReferenceValue } from "../helpers/references";
var HoverableValueMixin = {
  showHoverableValue: function(value) {
    if (_.isEmpty(value)) {
      return null;
    }
    value = cleanReferenceValue(value);
    var classes = classNames({
      "hoverable-value-table__value": true,
      "hoverable-value-table__value--selected": this.state.selectedValue === value
    });
    return /* @__PURE__ */ React.createElement(
      "span",
      {
        onMouseEnter: _.partial(this.valueEntered, value),
        onMouseLeave: this.valueLeft,
        onClick: () => this.valueClicked(value),
        className: classes
      },
      value
    );
  },
  valueEntered: function(value) {
    if (this.props.onValueHighlighted) this.props.onValueHighlighted(value);
    this.setState({ selectedValue: value });
  },
  valueLeft: function() {
    if (this.props.onValueHighlighted) this.props.onValueHighlighted(void 0);
    this.setState({ selectedValue: void 0 });
  },
  valueClicked: function(value) {
    if (this.props.onValueClick) this.props.onValueClick(value);
  }
};
export { HoverableValueMixin };
